import { ActionsObservable, combineEpics, Epic, ofType, StateObservable } from 'redux-observable';
import { filter, map, mergeMap, pairwise, tap, withLatestFrom } from 'rxjs/operators';
import { GameItemConfig, ItemIDs } from '../../Config/Items';
import BoardArrangement from '../../Game/BoardArrangement';
// import Board from '../../Managers/Board';
import { HudActions, HudEmitter } from '../../Managers/Hud/HudEmitter';
import { BoosterTilePostfix, Suits } from '../../Tiles/TileSet';
import { Actions, ActionTypes, TAction } from '../Actions/Actions';
import { IGameState } from '../Store/store';
import { BoosterUtils } from '../../Managers/Boosters/BoosterUtils';

const addBoosterEpic: Epic<TAction, TAction, IGameState> = (
    action$: ActionsObservable<TAction<string, ItemIDs[]>>,
    state$: StateObservable<IGameState>
) => {
    return action$.pipe(
        ofType(ActionTypes.ADD_GAME_BOOSTER),
        withLatestFrom(state$),
        tap(([action, state]) => {
            // Board.showSelected(state.StateLevel.selected, state.StateBoard.boardMap);
            if (
                action.payload[0] !== ItemIDs.HINT &&
                state.StateBoosters.currentBoosters.includes(ItemIDs.HINT)
            ) {
                // Board.blockHints();
            }
        }),
        filter(([action]) => action.payload[0] !== ItemIDs.HINT),
        mergeMap(([action, state]) => {
            const actions = [];
            const fullId = action.payload[0];
            const [boosterId, postfix] = fullId.split('_');
            if (boosterId === ItemIDs.FIRECRACKER) {
                const isBoosterTile = postfix === BoosterTilePostfix;
                const config = GameItemConfig[boosterId];
                const strength = isBoosterTile ? config.tileStrength : config.strength;
                const testPairs = BoardArrangement.getPairsToRemove(
                    state.StateBoard.boardTiles,
                    strength,
                    state.StateBoard.boardMap,
                    false
                );
                const pairIds = testPairs.map(t => t.boardId);
                actions.push(Actions.storeMatches(pairIds));
            }
            if (!BoosterUtils.checkAutoBooster(boosterId as ItemIDs, state.StateLevel.levelIndex)) {
                actions.push(Actions.showBooster(fullId));
            }
            return actions;
        })
    );
};

const addHintBoosterEpic: Epic<TAction, TAction, IGameState> = (
    action$: ActionsObservable<TAction<string, ItemIDs[]>>,
    state$: StateObservable<IGameState>
) => {
    return action$.pipe(
        ofType(ActionTypes.ADD_GAME_BOOSTER),
        withLatestFrom(state$),
        filter(([action]) => action.payload[0] === ItemIDs.HINT),
        mergeMap(([action, state]) => {
            const firstPair = BoardArrangement.getPairsToRemove(
                state.StateBoard.boardTiles,
                1,
                state.StateBoard.boardMap
            );
            const firstIds = firstPair.map(t => t.boardId);
            return [Actions.storeHints(firstIds), Actions.showBooster(action.payload[0])];
        })
    );
};

/*const activateBoosterEpic: Epic<TAction, TAction, IGameState> = (
    action$: ActionsObservable<TAction<string, string>>,
    state$: StateObservable<IGameState>
) => {
    return action$.pipe(
        ofType(ActionTypes.ACTIVATE_BOOSTER),
        withLatestFrom(state$),
        tap(([action, state]) => {
            Board.showAvailable(state);
        }),
        mergeMap(([action]) => {
            const actions = [];
/!*            if (action.payload === ItemIDs.SHUFFLE || action.payload === ItemIDs.TIME) {
                actions.push(
                    Actions.removeBoosters([action.payload])
                    // Actions.setLevelStuck({ stuck: false })
                );
            }*!/
            return actions;
        })
    );
};*/

const activateFriendBoosterEpic: Epic<TAction, TAction, IGameState> = (
    action$: ActionsObservable<TAction<string, string>>,
    state$: StateObservable<IGameState>
) => {
    return action$.pipe(
        ofType(ActionTypes.ACTIVATE_FRIENDS_BOOSTERS),
        withLatestFrom(state$),
        mergeMap(([action, state]) => {
            const actions: any[] = [];
            for (const booster of state.StateBoosters.friendsBoosters) {
                if (action.payload) {
                    HudEmitter.instance.emit(HudActions.SHOW_ACTIVATION_PARACHUTE, booster);
                } else {
                    actions.push(Actions.silentStoreBooster([booster]));
                    actions.push(Actions.addBoosters([booster]));
                }
                actions.push(Actions.removeFriendBooster(booster));
            }
            return actions;
        })
    );
};

const removeBoosterEpic: Epic<TAction, TAction, IGameState> = (
    action$: ActionsObservable<TAction<string, string[0]>>,
    state$: StateObservable<IGameState>
) => {
    return action$.pipe(
        ofType(ActionTypes.REMOVE_GAME_BOOSTER),
        withLatestFrom(state$),
        tap(([_, state]) => {
            // Board.showAvailable(state);
        }),
        map(([_, state]) => {
            if (state.StateBoosters.currentBoosters.includes(ItemIDs.HINT)) {
                // dirty stuff that works
                const nextPair = BoardArrangement.getPairsToRemove(
                    state.StateBoard.boardTiles,
                    1,
                    state.StateBoard.boardMap
                );

                if (nextPair.length > 0) {
                    const nextIds = nextPair.map(t => t.boardId);
                    return Actions.storeHints(nextIds);
                } else {
                    return Actions.removeBoosters([ItemIDs.HINT]);
                }
            }

            return Actions.completeAction();
        })
    );
};

const selectTriggerMagnetEpic: Epic<TAction, TAction, IGameState> = (
    action$: ActionsObservable<TAction<string, string>>,
    state$: StateObservable<IGameState>
) => {
    return action$.pipe(
        ofType(ActionTypes.SELECT_TILE),
        withLatestFrom(state$),
        filter(([_, state]) => state.StateBoosters.waitingBoosters.includes(ItemIDs.MAGNET)),
        mergeMap(([action, state]) => {
            let capturedTiles = BoardArrangement.getAllOfMatchingType(
                action.payload,
                state.StateBoard.boardTiles,
                state.StateBoard.boardMap
            );

            const m = state.StateBoard.boardMap;
            const magnetTile = m[action.payload];

            capturedTiles = capturedTiles.sort((a, b) => {
                const xA = Math.abs(m[a].position[1] - magnetTile.position[1]);
                const yA = Math.abs(m[a].position[2] - magnetTile.position[2]);
                const xB = Math.abs(m[b].position[1] - magnetTile.position[1]);
                const yB = Math.abs(m[b].position[2] - magnetTile.position[2]);
                return xB + yB - (xA + yA);
            });
            // add magnet last
            capturedTiles.splice(capturedTiles.indexOf(action.payload), 1);
            capturedTiles = capturedTiles.slice(0, GameItemConfig[ItemIDs.MAGNET].strength);
            capturedTiles.push(action.payload);
            return [Actions.storeMatches(capturedTiles), Actions.activateBooster(ItemIDs.MAGNET)];
        })
    );
};

const storeMagnetEpic: Epic<TAction, TAction, IGameState> = (
    action$: ActionsObservable<TAction<string, string>>,
    state$: StateObservable<IGameState>
) => {
    return action$.pipe(
        ofType(ActionTypes.STORE_MATCHES),
        withLatestFrom(state$),
        filter(([_, state]) => state.StateBoosters.currentBoosters.includes(ItemIDs.MAGNET)),
        mergeMap(() => {
            return [Actions.completeAction()];
        })
    );
};

const useHintEpic: Epic<TAction, TAction, IGameState> = (
    action$: ActionsObservable<TAction<string, string[][]>>,
    state$: StateObservable<IGameState>
) => {
    return action$.pipe(
        ofType(ActionTypes.REMOVE_MATCH),
        withLatestFrom(state$),
        filter(([_, state]) => state.StateBoosters.currentBoosters.includes(ItemIDs.HINT)),
        map(([action, state]) => {
            let f = false;
            const currentHintMatch = state.StateLevel.hints.slice(
                state.StateLevel.hints.length - 2
            );

            // if EITHER tile in match is in current hint pair
            action.payload[0].forEach(id => {
                if (currentHintMatch.includes(id)) {
                    f = true;
                }
            });

            if (f) {
                const nextPair = BoardArrangement.getPairsToRemove(
                    state.StateBoard.boardTiles,
                    1,
                    state.StateBoard.boardMap
                );

                if (nextPair.length > 0) {
                    const nextIds = nextPair.map(t => t.boardId);
                    return Actions.storeHints(nextIds);
                } else {
                    return Actions.removeBoosters([ItemIDs.HINT]);
                }
            }

            return Actions.completeAction();
        })
    );
};
const useHighlightEpic: Epic<TAction, TAction, IGameState> = (
    action$: ActionsObservable<TAction<string, string[][]>>,
    state$: StateObservable<IGameState>
) => {
    return action$.pipe(
        ofType(ActionTypes.REMOVE_MATCH),
        withLatestFrom(state$),
        filter(([_, state]) => state.StateBoosters.currentBoosters.includes(ItemIDs.HIGHLIGHT)),
        map(([action, state]) => {
            if (state.StateLevel.levelIndex <= 8 || state.StateLevel.levelIndex === 18) {
                return Actions.completeAction();
            }

            if (state.StateBoosters.matchCounter < GameItemConfig[ItemIDs.HIGHLIGHT].duration - 1) {
                return Actions.incrementBoosterMatch();
            } else {
                // Board.clearHighlight();
                return Actions.removeBoosters([ItemIDs.HIGHLIGHT]);
            }
        })
    );
};

const removeStored: Epic<TAction, TAction, IGameState> = (
    action$: ActionsObservable<TAction<string, string>>,
    state$: StateObservable<IGameState>
) => {
    const statePairs$ = state$.pipe(pairwise());
    return action$.pipe(
        ofType(ActionTypes.REMOVE_STORED),
        withLatestFrom(statePairs$),
        mergeMap(([, [oldState]]) => {
            const actions: Array<any> = [];
            if (oldState.StateLevel.removes.length % 2 === 0) {
                const tile = oldState.StateBoard.boardMap[oldState.StateLevel.removes[0]];
                const tileSuit = !tile ? 'none' : tile.tileType.suit;
                const removeSuit = tileSuit === Suits.GOLD ? Suits.GOLD : 'pair';
                const removeActions = [Actions.registerMove([removeSuit])];
                return [...removeActions];
            }

            return [...actions];
        })
    );
};

const displayBoosterEpic: Epic<TAction, TAction, IGameState> = (
    action$: ActionsObservable<TAction<string, string[]>>,
    state$: StateObservable<IGameState>
) => {
    return action$.pipe(
        ofType(ActionTypes.ADD_GAME_BOOSTER, ActionTypes.STORE_GAME_BOOSTER),
        withLatestFrom(state$),
        map(() => {
            return Actions.completeAction();
        })
    );
};

const boosterEpic = combineEpics(
    addBoosterEpic,
    addHintBoosterEpic,
    displayBoosterEpic,
    removeStored,
    /*    activateBoosterEpic,*/
    activateFriendBoosterEpic,
    selectTriggerMagnetEpic,
    storeMagnetEpic,
    removeBoosterEpic,
    useHintEpic,
    useHighlightEpic
);

export default boosterEpic;
